import React from 'react';
import { Button } from '../ui/Button';
import { Check, Lock, X } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-16 md:py-24 bg-brand-night" data-id="element-71">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="text-center mb-12" data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-cream mb-4" data-id="element-74">
            Stop Being "Wired but Tired."
          </h2>
          <p className="text-brand-parchment text-lg" data-id="element-75">
            Your brain deserves a break. Your body deserves to heal.
          </p>
        </div>

        {/* Price comparison */}
        <div className="bg-brand-surface border border-brand-border rounded-2xl p-8 mb-8 space-y-4" data-id="element-76">
          {[{
          label: 'Sleep supplements',
          price: '$80–200/month',
          crossed: true
        }, {
          label: 'Sleep coaching',
          price: '$300+/session',
          crossed: true
        }, {
          label: 'Prescription sleep aids',
          price: 'Side effects + dependency',
          crossed: true
        }].map((item, i) => <div key={i} className="flex items-center justify-between text-brand-muted" data-id="element-77">
              <div className="flex items-center gap-2" data-id="element-78">
                <X className="h-4 w-4 text-red-500/60" data-id="element-79" />
                <span className="line-through text-sm" data-id="element-80">{item.label}</span>
              </div>
              <span className="text-sm line-through" data-id="element-81">{item.price}</span>
            </div>)}
          <div className="border-t border-brand-border pt-4 flex items-center justify-between" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <Check className="h-5 w-5 text-brand-amber" data-id="element-84" />
              <span className="font-bold text-brand-cream" data-id="element-85">
                The Deep Sleep Cortisol Reset
              </span>
            </div>
            <span className="font-bold text-brand-amber text-xl" data-id="element-86">
              $6,39 — One Time
            </span>
          </div>
        </div>

        {/* CTA box */}
        <div className="bg-brand-amber/10 border border-brand-amber/30 rounded-2xl p-8 text-center shadow-amber" data-id="element-87">
          {/* Discount badge */}
          <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-500/40 text-red-400 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-88">
            <span data-id="element-89">🔥</span> 70% OFF — Launch Price
          </div>

          <div className="flex items-center justify-center gap-4 mb-1" data-id="element-90">
            <span className="text-brand-muted line-through text-2xl font-medium" data-id="element-91">
              $21,30
            </span>
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-92">
              -70%
            </span>
          </div>
          <div className="text-6xl font-bold text-brand-amber mb-1" data-id="element-93">$6,39</div>
          <div className="text-brand-parchment text-sm font-medium mb-8 uppercase tracking-widest" data-id="element-94">
            One-time payment — Instant Access
          </div>

          <Button fullWidth className="mb-4 text-xl py-5" data-id="element-95">
            Download the Reset — $6,39
          </Button>

          <div className="flex items-center justify-center gap-6 text-xs text-brand-muted mt-4" data-id="element-96">
            <span className="flex items-center gap-1" data-id="element-97">
              <Check className="h-3 w-3 text-brand-amber" data-id="element-98" /> Instant PDF
              Download
            </span>
            <span className="flex items-center gap-1" data-id="element-99">
              <Check className="h-3 w-3 text-brand-amber" data-id="element-100" /> 40-Page Blueprint
            </span>
            <span className="flex items-center gap-1" data-id="element-101">
              <Lock className="h-3 w-3 text-brand-amber" data-id="element-102" /> Secure Checkout
            </span>
          </div>

          <p className="text-brand-muted text-xs mt-4" data-id="element-103">
            Join 2,400+ professionals who sleep through the night.
          </p>
        </div>
      </div>
    </section>;
}